import React, { Component } from 'react';

import { Select } from 'components/input';
import { translate } from 'components/translate';
import { filtersOptions } from 'modules/userManager/helper';
import UserManagerService from 'modules/userManager/UserManagerService';
import { userFilterFields } from 'modules/userManager/userSearch/deepSearch/constants';
import PropTypes from 'prop-types';

@translate()
export default class DeepSearchSelect extends Component {
  static propTypes = {
    t: PropTypes.func,
    name: PropTypes.string,
    field: PropTypes.string,
    placeholder: PropTypes.string,
    onMenuOpen: PropTypes.func,
    setValueSelect: PropTypes.func,
    options: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    className: PropTypes.string,
    isDisabled: PropTypes.bool,
    setFieldValue: PropTypes.func,
    error: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  };

  static defaultProps = {
    className: '',
    isDisabled: false
  };

  get userTypeList() {
    return UserManagerService.userTypeList;
  }

  get userStatusList() {
    return filtersOptions().userStatus;
  }

  get accessPlusAllList() {
    return [
      {
        value: '',
        label: this.props.t('users_manager.users_list.header.tab_all_users')
      },
      {
        value: 'YES',
        label: this.props.t('general.yes')
      },
      {
        value: 'WITHOUT_PLUS_ACCESS',
        label: this.props.t('general.no')
      }
    ];
  }

  get userPlusAccessList() {
    return filtersOptions().userPlusAccess;
  }

  get userLocaleList() {
    return filtersOptions().locale;
  }

  get value() {
    const { field, value } = this.props;

    if (value && typeof value === 'string') {
      const list = `${
        field === userFilterFields.userJoinType ? 'userType' : field
      }List`;

      return this[list].find((item) => item.value === value);
    }

    return value;
  }

  render() {
    const {
      name,
      field,
      placeholder,
      setValueSelect,
      options,
      className,
      isDisabled,
      error
    } = this.props;

    return (
      <Select
        name={name}
        className={className}
        value={this.value}
        marginBottom={false}
        placeholder={placeholder}
        options={this[options] || options}
        onChange={(option) => setValueSelect(option, field)}
        isDisabled={isDisabled}
        hasError={error}
      />
    );
  }
}
